import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Tabs } from './tabs.component';
import { TabItem } from './tab-item.component';

export { Tabs } from './tabs.component';
export { TabItem } from './tab-item.component';

@NgModule({
  declarations: [
    Tabs,
    TabItem,
  ],
  exports: [
    Tabs,
    TabItem,
  ],
  imports: [
    CommonModule
  ]
})
export class TabsModule { }
